import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { orderSessions, trainingError } from "../../lib/training";
import { SessionRow } from "./SessionsPanel";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";
import { Plus } from "lucide-react";

// Training sessions of a mission, a pharmacy or a collaborator: the sessions list filtered, with its own visibility (the server's).
// `createLink` = where « Nouvelle session » leads (only passed to whoever may prepare one); `hideWhenEmpty` for a fiche.
export default function RelatedSessions({ params, title = "Formations", createLink, hideWhenEmpty = false, emptyText, testid = "related-sessions" }) {
  const [state, setState] = useState({ phase: "loading", items: [], error: "" });
  const key = JSON.stringify(params);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/training/sessions", { params: JSON.parse(key) });
      setState({ phase: "ready", items: orderSessions(data.items), error: "" });
    } catch (e) {
      setState({ phase: "error", items: [], error: trainingError(e, "Impossible de charger les formations.") });
    }
  }, [key]);
  useEffect(() => { load(); }, [load]);

  if (state.phase === "loading") return <Card className="p-5"><Skeleton className="h-12 w-full" /></Card>;
  if (hideWhenEmpty && state.phase === "ready" && state.items.length === 0) return null;
  return (
    <Card className="overflow-hidden" data-testid={testid}>
      <div className="flex items-center justify-between gap-2 px-4 pt-4 pb-2">
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
        {createLink && (
          <Button variant="outline" size="sm" asChild data-testid={`${testid}-new`}>
            <Link to={createLink}><Plus size={14} className="mr-1.5" />Nouvelle session</Link>
          </Button>
        )}
      </div>
      {state.phase === "error" && (
        <div className="px-4 pb-4 text-sm text-slate-600 flex items-center gap-2 flex-wrap">{state.error}<Button variant="outline" size="sm" onClick={load}>Réessayer</Button></div>
      )}
      {state.phase === "ready" && state.items.length === 0 && (
        <p className="px-4 pb-4 text-sm text-slate-500">{emptyText || "Aucune session de formation."}</p>
      )}
      {state.items.length > 0 && <div className="divide-y divide-slate-100 border-t border-slate-100">{state.items.map((s) => <SessionRow key={s.id} session={s} showPharmacy={!params.prospect_id} />)}</div>}
    </Card>
  );
}
